/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeactivateMultipleActiveInstrumentsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/DeactivateMultipleActiveInstruments.pb'
import {DeactivateMultipleActiveInstrumentsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/DeactivateMultipleActiveInstruments.pb'


export const deactivateMultipleActiveInstruments = (request:DeactivateMultipleActiveInstrumentsRequest, options?: CashRequestOptions) => post<DeactivateMultipleActiveInstrumentsRequest, DeactivateMultipleActiveInstrumentsResponse>("/2.0/cash/deactivate-multiple-active-instruments", request, {...options, rejectOnError: true })